export var SystemCriticalFlagsEnum;
(function (SystemCriticalFlagsEnum) {
    SystemCriticalFlagsEnum["IS_IN_MEMORY_CLUSTER_MODE_ENABLED"] = "IS_IN_MEMORY_CLUSTER_MODE_ENABLED";
})(SystemCriticalFlagsEnum || (SystemCriticalFlagsEnum = {}));
